import React from 'react';
import './Goals.scss';
import { safeHtml } from '../../../../services/helpers';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function Goals({ strapiData, setShowEbookModal }) {

    if (!strapiData) return null;

    const handleButtonClick = () => {
        setShowEbookModal(true);
    };

    return (
        <section className='ebook-goals'>
            <div className="ebook-goals__content">
                <h2 className="ebook-goals__title">{strapiData.Titre}</h2>
                <ul className="ebook-goals__list">
                    {strapiData.Objectifs.map((goal, index) => (
                        <li key={index} className="ebook-goals__goal">
                            <StrapiImageWithSkeleton
                                picture={goal.Photo}
                                loading="lazy"
                                size="small"
                            />
                            <span className="ebook-goals__goal-text">{goal.Titre}</span>
                        </li>
                    ))}
                </ul>
                <div className="ebook-goals__text" dangerouslySetInnerHTML={safeHtml(strapiData.Texte)} />
                <CustomBtn
                    type={'action'}
                    title={strapiData.TexteBouton}
                    on_click={handleButtonClick}
                    bkg_color={'#361215'}
                    bkg_color_hover={'#EEE6DB'}
                    text_color={'#EEE6DB'}
                    text_color_hover={'#361215'}
                    border_color={'#EEE6DB'}
                    border_color_hover={'#361215'}
                    font_family={"Playfair Display"}
                    font_size={'20px'}
                    font_weight={'normal'}
                    border_radius={'3px'}
                    width={'430px'}
                    height={'55px'}
                    margin={'10px 0'}
                    letter_spacing={'2px'}
                />
            </div>
        </section>
    )
}
